import { useState } from "react";
import { AboutContent, MethodologyContent } from './ContentComponents'; // Adjust the import path as necessary
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
const pages = ["Methodology", "About"];

export default function Header({ navClick }) {
    const [anchorElNav, setAnchorElNav] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogContent, setDialogContent] = useState("");

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleDialogOpen = (page) => {
        if(page === 'Methodology'){
            window.open('/btcCO2emissions/methodology.pdf', '_blank');
            return
        }
        setDialogContent(page);
        setOpenDialog(true);
    };

    const handleDialogClose = () => {
        setOpenDialog(false);
    };

    return (
        <AppBar position="static" color="inherit" sx={{ minHeight: 'auto' }}>
            <Container maxWidth="xl">
                <Toolbar variant="dense" disableGutters sx={{ minHeight: '3rem', py: 0.5 }}>
                    {/* Logo on the left */}
                    <img 
                        src={`${process.env.PUBLIC_URL}/images/york-logo.jpeg`} 
                        alt="York University" 
                        title="York University" 
                        width="100" 
                        loading="eager"
                        style={{ marginRight: '12px', verticalAlign: 'middle' }} 
                    />

                    {/* Space box to center the title */}
                    <Box sx={{ flexGrow: 1.2 }} />

                    {/* Title in the center */}
                    <Typography
                        variant="h6" 
                        noWrap
                        component="a"
                        href="/"
                        sx={{
                            flexGrow: 0,
                            color: 'inherit',
                            textDecoration: 'none',
                            alignSelf: 'center',
                            fontSize: '1.4rem',
                            fontWeight: 'bold',
                            lineHeight: 1.2,
                        }}
                    >
                        Bitcoin CO<sub>2</sub> Emissions Project
                    </Typography>

                    {/* Space box to center the title */}
                    <Box sx={{ flexGrow: 1 }} />

                    {/* Navigation links on the right */}
                    <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center' }}>
                        {pages.map((page) => (
                            <Button 
                                key={page} 
                                onClick={() => handleDialogOpen(page)} 
                                sx={{ 
                                    display: 'block', 
                                    my: 0, 
                                    color: 'black',
                                    fontSize: '0.875rem',
                                    padding: '0.25rem 0.75rem',
                                    minWidth: 'auto'
                                }}
                            >
                                {page}
                            </Button>
                        ))}
                    </Box>

                    {/* Mobile menu icon */}
                    <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                            }}
                        >
                            {pages.map((page) => (
                                <MenuItem key={page} onClick={() => handleDialogOpen(page)}>
                                    <Typography textAlign="center" sx={{ color: 'black' }}>{page}</Typography>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                </Toolbar>
            </Container>

            {/* Dialog for About and Methodology */}
            <Dialog open={openDialog} onClose={handleDialogClose}>
                <DialogTitle>{dialogContent}</DialogTitle>
                <DialogContent>
                    {/* Content for the dialog */}
                    {dialogContent === "About" && <AboutContent />}
                    {dialogContent === "Methodology" && <MethodologyContent />}
                </DialogContent>
            </Dialog>
        </AppBar>
    );
}
